// extracted by mini-css-extract-plugin
module.exports = {"container":"SegmentWorkList_container__2Ngtd","name":"SegmentWorkList_name__1-rF8","date":"SegmentWorkList_date__34nsL"};